import { vaultPostRequest } from '../helpers';
import type { IEnqueueImgJobsRequest } from './enqueue-img-jobs-request';
import {
  enqueueImgJobsResponseSchema,
  type IEnqueueImgJobsResponse,
} from './enqueue-img-jobs-response';

export async function enqueueImgJobsApi(
  body: IEnqueueImgJobsRequest,
): Promise<IEnqueueImgJobsResponse> {
  return vaultPostRequest({ path: '/img/enqueue', body, schema: enqueueImgJobsResponseSchema });
}
